import type {
  EmailFailureResponse,
  EmailFailuresReprocessResponse,
  EmailFailuresResponse,
  EmailFailuresTriageResponse,
} from '@anery/api-contracts';

import { parseInstante } from '../../../shared/dominio/datas';
import {
  ETAPAS_DA_FALHA,
  type EtapaConhecidaOuNao,
  type FalhaDeEmail,
  type PaginaDeFalhas,
  type ResultadoDaTriagem,
  type ResultadoDoReprocesso,
} from './tipos';

function etapaDe(bruta: string | null): EtapaConhecidaOuNao {
  // Etapa nova que o front ainda não conhece NÃO derruba a fila: só esta linha
  // sai como "Etapa desconhecida". Lançar aqui esconderia todas as outras falhas
  // por causa de uma — o contrário do que uma fila de erro existe para fazer.
  return ETAPAS_DA_FALHA.find((candidata) => candidata === bruta) ?? 'desconhecida';
}

export function mapearFalhaDeEmail(bruta: EmailFailureResponse): FalhaDeEmail {
  return {
    id: bruta.id,
    etapa: etapaDe(bruta.stage),
    caixa: bruta.mailbox ?? '',
    motivo: bruta.reason ?? '',
    tentativas: bruta.attempts,
    primeiraEm: parseInstante(bruta.firstAt),
    ultimaEm: parseInstante(bruta.lastAt),
    esgotada: bruta.exhausted,
    reprocessavel: bruta.reprocessable,
    triavel: bruta.triable,
  };
}

export function mapearPaginaDeFalhas(bruta: EmailFailuresResponse): PaginaDeFalhas {
  return {
    itens: (bruta.items ?? []).map(mapearFalhaDeEmail),
    total: bruta.total,
  };
}

export function mapearResultadoDoReprocesso(bruto: EmailFailuresReprocessResponse): ResultadoDoReprocesso {
  return {
    tentadas: bruto.seen,
    reprocessadas: bruto.reprocessed,
    naoEncontradas: bruto.notFound,
    falharam: bruto.failed,
    aindaHaFila: bruto.moreRemaining,
  };
}

export function mapearResultadoDaTriagem(bruto: EmailFailuresTriageResponse): ResultadoDaTriagem {
  return {
    vistos: bruto.seen,
    abertos: bruto.opened,
    vinculados: bruto.linked,
    reabertos: bruto.reopened,
    falharam: bruto.failed,
    aindaHaFila: bruto.moreRemaining,
  };
}
